import Component from '../../js/_Component';

export default class Form extends Component {
	private form: HTMLFormElement;

	private fields: (HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement)[];

	private successMessage: HTMLElement;

	private failureMessage: HTMLElement;

	constructor(element: HTMLElement) {
		super(element);

		this.form = element.querySelector('form');
		this.fields = Array.from(element.querySelectorAll('[name]'));
		this.successMessage = element.querySelector('.c-form__success-message');
		this.failureMessage = element.querySelector('.c-form__failure-message');

		this.form.addEventListener('submit', (event) => {
			event.preventDefault();
			this.submit();
		});
	}

	collectData() {
		const data = {
			form: this.form.dataset.name,
		};

		this.fields.forEach((field) => {
			data[field.name] = field.value;
		});

		return data;
	}

	submit() {
		const data = this.collectData();

		const fetchOptions = {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify(data),
		};

		fetch(this.form.dataset.endpoint, fetchOptions)
			.then((response) => response.json())
			.then((response) => this.onSuccess(response))
			.catch(() => this.onFailure());
	}

	onSuccess(response) {
		if (!response.success) {
			this.onFailure();
			return;
		}

		this.form.style.display = 'none';
		this.successMessage.style.display = 'block';
	}

	onFailure() {
		this.form.style.display = 'none';
		this.failureMessage.style.display = 'block';
	}
}

Component.register(Form, 'Form');
